<ng-container *ngIf="iconPath">
  <img
    [src]="iconPath"
    [attr.width]="width"
    [attr.height]="height"
    [alt]="name"
  >
</ng-container>